/* Automatic reviews; each instance owns its timer and editor listeners. */
if (!customElements.get('tl-compact-reviews')) {
  customElements.define('tl-compact-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.editorSelected = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-review-slide]');
        const index = this.slides.indexOf(slide);
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index);
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.schedule();
      }, options);
      this.show(0);
      this.schedule();
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.index;
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        slide.style.transform = `translateX(${(position - this.index) * 100}%)`;
      });
      // Allow the quick transition to finish, then hold for 4.5 seconds.
      // Reduced-motion visitors still see every review, without animation.
      this.schedule(this.motion.matches ? 4500 : 4750);
    }

    schedule(delay = 4500) {
      clearTimeout(this.timer);
      if (!this.isConnected || this.editorSelected || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
}
